import React, { useEffect, useState } from 'react';
import { ArrowRight } from 'lucide-react';
import { trackEvent, appendUTMsToUrl } from '../services/analytics';

const APP_URL = 'https://app.botibonga.com';

export default function StickyMobileCTA({ ctaLabel = 'Get Started Free', source = 'sticky' }) {
  const [show, setShow] = useState(false);
  const [keyboardOpen, setKeyboardOpen] = useState(false);

  useEffect(() => {
    // Show after scrolling 60% of one viewport — past the hero on most layouts.
    const threshold = () => window.innerHeight * 0.6;
    const onScroll = () => setShow(window.scrollY > threshold());
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    // Hide when on-screen keyboard pushes the layout viewport up — covers
    // the form so the user can see what they're typing.
    if (typeof window === 'undefined' || !window.visualViewport) return undefined;
    const vv = window.visualViewport;
    const onResize = () => {
      const heightDelta = window.innerHeight - vv.height;
      setKeyboardOpen(heightDelta > 150);
    };
    vv.addEventListener('resize', onResize);
    return () => vv.removeEventListener('resize', onResize);
  }, []);

  const handleClick = (e) => {
    trackEvent('cta_click', { location: 'sticky_mobile', label: ctaLabel, source });
    const target = appendUTMsToUrl(APP_URL);
    if (target !== APP_URL) {
      e.currentTarget.href = target;
    }
  };

  if (!show || keyboardOpen) return null;

  return (
    <div
      className="md:hidden fixed bottom-0 left-0 right-0 z-40 px-3 pt-2 pb-[max(0.75rem,env(safe-area-inset-bottom))]"
      style={{
        background: 'var(--bg-navbar, rgba(255,255,255,0.92))',
        backdropFilter: 'blur(12px)',
        WebkitBackdropFilter: 'blur(12px)',
        borderTop: '1px solid var(--border-navbar, rgba(0,0,0,0.06))',
      }}
    >
      <a
        href={APP_URL}
        onClick={handleClick}
        className="flex items-center justify-center gap-2 w-full px-5 py-3 rounded-xl text-sm font-semibold text-white transition-all duration-200 active:scale-[0.98]"
        style={{
          background: 'linear-gradient(135deg, #6366f1 0%, #8b5cf6 100%)',
          boxShadow: 'var(--shadow-btn)',
        }}
      >
        {ctaLabel}
        <ArrowRight className="w-4 h-4" />
      </a>
    </div>
  );
}
